import {BaseService} from "./BaseService";
import {QueuedCommand} from "../entities/QueuedCommand";
import { StateService } from "@uirouter/angularjs";

export class QueuedCommandService extends BaseService<QueuedCommand>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, QueuedCommand);
    }
    protected getBaseUrl():string{
        return "queuedcommand";
    }
    getCountByTypeStatus(commandType:string,status:string,search:string,before:string):ng.IPromise<number>{
        var config:any = {};
        return this.useGetHandler(this.getBasesUrl(),"CountByType?commandType="+commandType+"&status="+status+"&search="+search+"&before="+before, config);
    }

    getPagedByTypeStatus(commandType:string,status:string,search:string,before:string,page:number,pageSize:number,
                         orderColumn:string,orderDirection:string):ng.IPromise<QueuedCommand[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"PagedByType?commandType="+commandType+"&status="+status+"&search="+search+"&before="+before+"&page="+page+"&pageSize="+pageSize+"&orderColumn="+orderColumn+"&orderDirection="+orderDirection, config);
    }

    deleteOld(){
        var config:any = {};
        return this.useBaseGetHandler(this.getBasesUrl(),"Old", config);
    }

    getActive(commandType:string, assetId:number):ng.IPromise<QueuedCommand[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"Active", config);
    }

    getQueued():ng.IPromise<QueuedCommand[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"Queued", config);
    }

    getRetry():ng.IPromise<QueuedCommand[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"Retry", config);
    }

    updateLastAttempt(queuedCommandId:number){
        var config:any = {};
        return this.useGetHandler(this.getBaseUrl(),"ListAttempt/"+queuedCommandId, config);
    }

    getQueuedCommandsByReader(available:number, gatewayId:number):ng.IPromise<QueuedCommand[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"QueuedByReader?available="+available+"&gatewayId="+gatewayId, config);
    }

    updateStatus(id:number,status:string,reason:string){
        var config:any = {};
        return this.usePutHandler(this.getBaseUrl(),"Status?id="+id+"&status="+status+"&reason="+reason, config);
    }

    getRetryCommandsByReader(top:number,readerId:number):ng.IPromise<QueuedCommand[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"RetryByReader?top="+top+"&readerId="+readerId, config);
    }

    incrementRetry(queuedCommandId:number){
        var config:any = {};
        return this.usePutHandler(this.getBaseUrl(),"incrementRetry/"+queuedCommandId, config);
    }
}
